<template>
  <div class="w-full mb-2">
    <div class="
            pointer-events-auto
            mb-1
            border-transparent
            rounded-lg
            transition-all
            ease-linear
            duration-100
            bg-[#f5f6f8]
            relative
            border-2
          "
      :class="{ 'border-danger': err_msg || invalid, 'border-black': focus_border, 'opacity-60 cursor-not-allowed': disabled }">
      <div class="flex items-center pl-3 w-full h-full">
        <input :type="type" class="text-sm leading-6 resize-y" :value="value" @change="changeInput" @focus="focusInput"
          @blur="blurInput" ref="input" :required="required" :placeholder="focus ? placeholder : ''"
          :disabled="disabled" />
      </div>
      <div class="
              label-fix
              flex
              absolute
              top-[10px]
              left-3
              h-auto
              items-center
              w-full
            " :class="{ active: focus || value, 'text-danger': err_msg || invalid }">
        {{ label }}
      </div>
    </div>
    <span class="text-danger text-xs">
      {{ err_msg }}
    </span>
  </div>
</template>
  
<script>
export default defineComponent({
  props: {
    value: {
      default: "",
    },
    type: {
      type: String,
      default: "text",
    },
    format: {
      type: String,
      default: "text",
    },
    maxLength: {
      type: Number,
    },
    label: {
      default: "",
      type: String,
    },
    placeholder: {
      default: "",
      type: String,
    },
    required: {
      default: false,
      type: Boolean,
    },
    disabled: {
      default: false,
      type: Boolean,
    },
    invalid: {
      default: false,
      type: Boolean,
    },
  },
  mounted() {
    if (this.value || this.type == "number") {
      this.focus = true;
    }
  },
  methods: {
    focusInput(e) {
      this.focus_border = true;
      this.focus = true;
    },
    changeInput(e) {
      if (!e.target.value) {
        this.focus = false;
        this.$emit("update:value", null);
        this.err_msg = "";
      } else {
        this.validateForm(e.target.value);
      }
    },
    blurInput(e) {
      this.focus_border = false;
      if (!e.target.value) {
        this.focus = false;
        this.$emit("update:value", null);
        this.err_msg = "";
      } else {
        this.validateForm(e.target.value);
      }
    },
    validateForm(val) {
      if (val === "") {
        val = null;
      }

      this.$emit("update:value", val);
      if (val == "") {
        this.err_msg = "";
        this.focus = false;
        return;
      }
      switch (this.format) {
        case "email":
          if (!this._validate.email(val)) {
            this.err_msg = "Please enter an email address";
          } else {
            this.err_msg = "";
          }
          break;
        case "url":
          if (!this._validate.url(val)) {
            this.err_msg = "Please enter a URL";
          } else {
            this.err_msg = "";
          }
          break;
        case "phone":
          if (!this._validate.phone(val)) {
            this.err_msg =
              "Phone number cannot include alphabetical characters";
          } else {
            this.err_msg = "";
          }
          break;
      }
    },
  },
  data() {
    return {
      focus: false,
      err_msg: "",
      focus_border: false,
    };
  },
});
</script>
  
<style scoped lang="scss">
input {
  background-color: transparent;
  background-image: none;
  border: none;
  box-shadow: none;
  padding: 16px 12px 0px 0px;
  font: inherit;
  box-sizing: border-box;
  appearance: none;
  border-radius: 8px;
  color: rgb(10, 11, 13);
  width: 100%;
  height: 44px;

  &:focus {
    outline: none;
    border: none;
    box-shadow: none;
  }
}

.label-fix {
  transform: scale(1) translateY(0px);
  transition: transform 0.1s linear 0s;
  transform-origin: left top;
  pointer-events: none;

  &.active {
    transform: scale(0.85) translateY(-8px);
  }

  p {
    padding: 0px;
    margin: 0px;
    color: rgb(104, 109, 115);
    font-size: 14px;
    line-height: 1.57;
  }
}
</style>
  